import React, { memo, forwardRef } from "react";
const SvgCapitalJ = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.05 18.41c0 .52-.06 1.067-.18 1.64a4.597 4.597 0 01-.62 1.6c-.306.493-.74.9-1.3 1.22-.56.32-1.28.48-2.16.48-.76 0-1.426-.133-2-.4a3.746 3.746 0 01-1.38-1.1c-.146-.2-.26-.387-.34-.56-.08-.187-.12-.38-.12-.58 0-.32.107-.593.32-.82.227-.227.514-.34.86-.34.187 0 .367.04.54.12.187.08.373.26.56.54.387.587.893.88 1.52.88.36 0 .654-.067.88-.2.24-.133.42-.32.54-.56.133-.253.227-.547.28-.88.053-.347.08-.72.08-1.12v-8.26c0-.293.047-.533.14-.72.093-.187.2-.333.32-.44a.938.938 0 01.42-.2c.147-.04.273-.06.38-.06.107 0 .233.02.38.06.147.027.28.093.4.2.133.107.247.253.34.44.093.187.14.427.14.72v8.34z"
      />
    </svg>
  );
});
SvgCapitalJ.displayName = "SvgCapitalJ";
const MemoForwardRef = memo(SvgCapitalJ);
export default MemoForwardRef;
